import PatientShow from './PatientShow';

export default PatientShow;
